import './alertLog.css';

export const alertLogDetail = ({ dataItem }) => {
  const { msg } = dataItem;
  const msgArr = msg.split('\n');

  return (
    <section>
      <div>
        <div className="alertLogDetailHeader">알림톡 메시지</div>
        <div className="alertLogDetailContent">
          {msgArr.map(item => {
            return item ? <div>{item}</div> : <br></br>;
          })}
          {/* <div>
            <div style={{ fontWeight: '500', padding: '5px' }}>
              {'['}
              {dataItem.ocurDtm} {dataItem.eventTypeTerm} 발생 {']'}
            </div>
          </div>
          <div>
            {dataItem.receiveTerm}담당자님, {dataItem.dongTerm} {dataItem.elderTerm} 대상자님의 위험이 감지되었습니다. 전화연결 및 방문이 필요합니다.
          </div>
          <br></br>
          <div>- 발생 일시 : {dataItem.ocurDtm}</div>
          <div>- 위험 감지 유형 : {dataItem.eventTypeTerm}</div>
          <div>
            - 대상자 : {dataItem.elderTerm} {dataItem.elderPhone}
          </div> */}
        </div>
      </div>
    </section>
  );
};
